import React from 'react';
import { Link } from 'react-router-dom';
import NewsletterForm from './NewsletterForm';
const Footer = () => (
  <div>
    <NewsletterForm />
   <footer className='footer-bg text-white pb-1'>
    <div className='container pt-5 pb-3'>
      <div className='row'>
        <div className="col me-3">
          <img src="https://webvexo.com/static/media/logo.3dd43b418798134d6d52.png" className="w-100"/>
           <p className="fs-7 mt-4"><i class="bi bi-geo-alt"></i> &nbsp;&nbsp;33 Washington Square W, New York, NY 10011, USA </p>
        </div>
        <div className='col mx-3'>
            <p className='mb-1'><Link to="https://webvexo.com/Webhosting" className='text-white fs-6'>Web Hosting</Link></p>
            <p className='mb-1'><Link to="https://webvexo.com/Aspnethosting" className='text-white fs-6'>ASP.Net Hosting</Link></p>
            <p className='mb-1'><Link to="https://webvexo.com/Emailhosting" className='text-white fs-6'>Email Hosting</Link></p>
        </div>
        
        <div className='col'>
          <p className='mb-1'><Link to="https://webvexo.com/SubscribeForm" className='text-white fs-6'>Subscribe</Link></p>
          <p className='mb-1'><Link to="https://webvexo.com/UnsubscribeForm" className='text-white fs-6'>Unsubscribe</Link></p>
          <p className='mb-1'><Link to="https://webvexo.com/Contact" className='text-white fs-6'>Contact</Link></p>
        </div>
        <div className='col'>
            <p className='mb-1'><Link to="https://webvexo.com/Vpscloud" className='text-white fs-6'>VPS & Cloud</Link></p>
            <p className='mb-1'><Link to="https://webvexo.com/Windowsvps" className='text-white fs-6'>Windows VPS</Link></p>
            <p className='mb-1'><Link to="https://webvexo.com/Storage" className='text-white fs-6'>Storage Servers</Link></p>
        </div>
      </div>
      
    </div>
    <hr/>
    <div className='container'>
    <div className='row'>
      <div className='col'>
        <p className=''>&copy; {new Date().getFullYear()} webvexo.com. All rights reserved.</p>
      </div>
      <div className='col'>
      <p className='mb-1 text-end'><Link to="https://webvexo.com/Policy" className='text-white fs-6'>Privacy Policy</Link>&nbsp;&nbsp;&nbsp;&nbsp; <Link to="https://webvexo.com/Terms" className='text-white fs-6'>Terms and Conditions</Link></p>
          <p className='mb-1'></p>
      </div>
    </div>
       </div>
  </footer>
  </div>
);
  export default Footer;
